import {
  TourEditorPage,
  clearTourEditorState,
  hasInitialTourEditorState,
  setInitialTourEditorState,
  useTourSelector,
} from '@carboncopyco/mimesis-sdk';
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { settings } from '../../../settings';
import { useCustomNavigate } from '../hooks/useCustomNavigate';
import useEditorGroupTab from '../hooks/useEditorGroupTab';
import useGetMimesisStepEngineUrl from '../hooks/useGetMimesisStepEngineUrl';
import { useTabManager } from '../services/TabManager';
import { useTabs } from '../store/context';

interface ITourEditorRoute {
  tabId: number;
}

const TourEditorRoute = ({ tabId }: ITourEditorRoute) => {
  const dispatch = useDispatch();
  const { getActiveGlobalTab, updateGlobalTabPayload, closeGlobalTab } =
    useTabManager();
  const globalTab = getActiveGlobalTab();
  const tabRootElement = useRef<HTMLDivElement>(null);
  const uuid = String(tabId);
  const isStateInitialised = useTourSelector(hasInitialTourEditorState(uuid));
  const { updateEditorTabVisibility } = useEditorGroupTab();

  const mimesisStepEngineRelativeUrl = useGetMimesisStepEngineUrl();

  const { isOpenCloseTabDialog, setIsOpenCloseTabDialog } = useTabs();

  useEffect(() => {
    if (!isStateInitialised) {
      dispatch(setInitialTourEditorState({ uuid }));
    }
  }, [isStateInitialised]);

  useEffect(() => {
    return () => {
      dispatch(clearTourEditorState({ uuid }));
    };
  }, []);

  return (
    <div
      className="flex flex-col flex-grow shrink basis-0 min-h-0 bg-white"
      ref={tabRootElement}
    >
      {isStateInitialised && (
        <TourEditorPage
          useNavigate={useCustomNavigate}
          mimesisStepEngineUrl={mimesisStepEngineRelativeUrl}
          fileServiceDynamicLink={settings.FILES_SERVICE_URL}
          isDebugMode={false}
          tabId={tabId}
          activeTabId={globalTab.id}
          rootElement={tabRootElement}
          uuid={uuid}
          deeplinkProtocol=""
          isDiscardModalOpen={isOpenCloseTabDialog && tabId === globalTab.id}
          setIsDiscardModalOpen={setIsOpenCloseTabDialog}
          onIsTourModifiedChange={(val: boolean) => {
            updateGlobalTabPayload(tabId, {
              draftModified: val,
            });
          }}
          onExit={() => {
            closeGlobalTab(globalTab?.id);
          }}
          onUpdateEditorTabVisibility={(show: boolean) =>
            updateEditorTabVisibility({
              editorTab: globalTab,
              show,
            })
          }
        />
      )}
    </div>
  );
};

export default TourEditorRoute;
